import React from 'react'
import SupportForm from './SupportForm'
import {sendSupportMessage} from '../../actions/index'
import { SubmissionError } from 'redux-form'
import _ from 'lodash'

const Support = (props) => {

    const handleSubmit = (values) => {
        console.log('handleSubmit', values)

        _.forEach([
            'name',
            'email',
            'subject',
            'body'], k => {
            if (!values[k]) {
                console.log('missing 1' , k)
                throw new SubmissionError({ _error: 'Fill out all the fields' })
            }
        })

        console.log('handleSubmit ok', values)

        props.dispatch(sendSupportMessage(values, () => {props.close()}))
    }

    //console.log('createTest', props, props.dataError)
    return (<div className="create-form-container">
        <div className="create-form-header">
            <h3>SUPPORT MESSAGE</h3>
        </div>

        <SupportForm
            onSubmit={handleSubmit}
            close={props.close}
            loading={props.loading}
        />

    </div>)
}

export default Support



// WEBPACK FOOTER //
// ./src/components/support/Support.jsx